import { axios } from '@/utils/request'
import ipConfig from '@../../../config/ip.config'

export const getOceanExportPageList = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetOceanExportPageList`,
  method: 'get',
  params: query
})

// export const getOceanExportPageList = (query) => axios({ // 查询
//   url: ipConfig.mcp_api + `/api/OceanExport/GetOceanExportPageList`,
//   method: 'get',
//   params: query
// })

export const getDataStatistics = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetDataStatistics`,
  method: 'get',
  params: query
})

export const getBusinessStatisticsTotal = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetBusinessStatisticsTotal`,
  method: 'get',
  params: query
})

export const getBusinessStatisticsCBMTotal = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetBusinessStatisticsCBMTotal`,
  method: 'get',
  params: query
})

export const getFileListByBookingNo = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetFileListByBookingNo`,
  method: 'get',
  params: query
})

export const getFileBlob = (data) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetFileBlob`,
  method: 'post',
  data
})

export const getFileBlobList = (data) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetFileBlobList`,
  method: 'post',
  data
})

export const getCFSContainerBining = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetCFSContainerBining`,
  method: 'get',
  params: query
})

export const getCFSContainerStatus = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetCFSContainerStatus`,
  method: 'get',
  params: query
})

export const getLCLCFSContainerBining = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetLCLCFSContainerBining`,
  method: 'get',
  params: query
})

export const GetSeaProts = (query) => axios({
  url: ipConfig.api_edi + `/api/OceanExport/GetSeaPortListForGrid`,
  method: 'get',
  params: query
})
